'use strict';

angular.module('ClinicApp').directive('editableButtons', function() {
  return {
    scope: {
      editor: '=',
      saveText: '@',
    },
    templateUrl: '/views/directives/_editable-buttons.html',
    link: function() {},
  };
});
